import CountrySearch, { CountrySearchProps } from "@components/form/CountrySearch";
import { Position } from "@hooks/useRelativeCoordsAndSize";
import { CountryCode } from "@lib/enums/generic";
import { JustifyContent, UIColor } from "@lib/types/generic";
import { useState } from "react";
import { Group, Showcase } from "./StyleGuide";

const CountrySearchs = () => {
  const sizes = [
    "extra-small",
    "small",
    "medium",
    "large",
    "extra-large",
  ] as CountrySearchProps["size"][];

  const [value, setValue] = useState(CountryCode.France);
  const [color, setColor] = useState<UIColor>("purple");
  const [textColor, setTextColor] = useState<UIColor>("white");
  const [optionColor, setOptionColor] = useState<UIColor>("purple");
  const [optionTextColor, setOptionTextColor] = useState<UIColor>("white");
  const [variant, setVariant] = useState<CountrySearchProps["variant"]>("contained");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [justifyContent, setJustifyContent] = useState<JustifyContent>("space-between");
  const [rounded, setRounded] = useState<boolean>(false);

  const props = {
    position: "portal-absolute" as Position,
    value,
    onChange: ({ value }: { value: CountryCode }) => setValue(value),
    color,
    textColor,
    optionColor,
    optionTextColor,
    variant,
    placeholder: "Placeholder",
    disabled,
    isLoading,
    justifyContent,
    rounded,
  };

  return (
    <Showcase
      title="Country Selects"
      className="country-selects"
      colors={[
        {
          color: color,
          label: "Color",
          onChange: setColor,
        },
        {
          color: textColor,
          label: "Text Color",
          onChange: setTextColor,
        },
        {
          color: optionColor,
          label: "Option Color",
          onChange: setOptionColor,
        },
        {
          color: optionTextColor,
          label: "Option Text Color",
          onChange: setOptionTextColor,
        },
      ]}
      selects={[
        {
          value: variant ?? "contained",
          optionsArray: ["contained", "outlined", "flat", "transparent"],
          label: "Variant",
          onChange: setVariant,
        },
        {
          value: justifyContent,
          optionsArray: ["space-between", "flex-start", "center", "flex-end"],
          label: "Justify",
          onChange: setJustifyContent,
        },
      ]}
      checkboxes={[
        {
          value: disabled,
          label: "Disabled",
          onChange: setDisabled,
        },
        {
          value: isLoading,
          label: "Is loading",
          onChange: setIsLoading,
        },
        {
          value: rounded,
          label: "Rounded",
          onChange: setRounded,
        },
      ]}>
      {sizes.map(size => (
        <Group key={size}>
          <CountrySearch size={size} {...props} />
        </Group>
      ))}
    </Showcase>
  );
};

export default CountrySearchs;
